import React from 'react';

const MyMatches = ({ matches, onBack, onChat }) => {
    return (
        <div className="mx-auto w-100 fade-in" style={{ maxWidth: '800px' }}>
            <div className="card glass-premium border-0 p-4 p-md-5 mb-4 shadow-lg mx-2" style={{ borderRadius: '45px' }}>
                <div className="d-flex align-items-center gap-3 mb-4">
                    <button className="btn btn-white shadow-sm rounded-circle d-flex align-items-center justify-content-center border-0" onClick={onBack} style={{ width: '40px', height: '40px' }}>
                        <i className="fas fa-arrow-left text-pink-600"></i>
                    </button>
                    <h2 className="fw-900 text-dark mb-0" style={{ fontSize: '1.8rem' }}>I Miei Match</h2>
                </div>

                {!matches || !Array.isArray(matches) || matches.length === 0 ? (
                    <div className="text-center py-5">
                        <div className="mb-4 opacity-20">
                            <i className="fas fa-heart-broken fa-4x text-pink-600"></i>
                        </div>
                        <h4 className="fw-700 text-dark mb-2">Ancora nessun match</h4>
                        <p className="text-muted">Partecipa ai prossimi eventi per incontrare nuove persone!</p>
                    </div>
                ) : (
                    <div className="row g-4">
                        {matches.map((m, idx) => (
                            <div className="col-12" key={idx}>
                                <div className="card glass-premium rounded-5 overflow-hidden transition-all hover-scale"
                                    style={{ background: m.isSuper ? 'linear-gradient(135deg, rgba(255,255,255,0.9), rgba(219,39,119,0.05))' : 'rgba(255,255,255,0.8)', border: m.isSuper ? '2px solid #db2777' : '1px solid rgba(219,39,119,0.1)' }}>
                                    <div className="p-3 p-md-4">
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <div className="d-flex align-items-center">
                                                <div className="rounded-circle shadow-sm overflow-hidden border border-white flex-shrink-0 me-3" style={{ width: '65px', height: '65px', border: m.isSuper ? '3px solid #db2777' : '3px solid #f8f9fa' }}>
                                                    {m.match.photo ? (
                                                        <img src={m.match.photo} alt={m.match.firstName} className="w-100 h-100 object-fit-cover" />
                                                    ) : (
                                                        <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-light">
                                                            <i className="fas fa-user text-pink-600 fs-3"></i>
                                                        </div>
                                                    )}
                                                </div>
                                                {m.isSuper && (
                                                    <span className="badge bg-white text-dark border-0 rounded-pill px-3 py-2 small shadow-sm fw-900 border border-warning" style={{ border: '1px solid #ffc107!important' }}>
                                                        <i className="fas fa-star me-2 text-warning"></i> SUPER MATCH
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="text-start overflow-hidden ps-1">
                                            <h4 className="fw-900 text-dark mb-1 text-truncate">
                                                {m.match.firstName} {m.match.lastName}
                                                {m.match.arrivalNumber && (
                                                    <span className="ms-2 badge bg-light text-pink-600 rounded-pill border border-pink-100" style={{ fontSize: '0.7rem', verticalAlign: 'middle' }}>
                                                        #{m.match.arrivalNumber}
                                                    </span>
                                                )}
                                            </h4>

                                            <div className="text-pink-600 fw-700 small mb-2 ls-sm text-truncate">
                                                <i className="fas fa-calendar-check me-2"></i>
                                                {m.eventName} - {new Date(m.eventDate).toLocaleDateString()}
                                            </div>

                                            <div className="mb-2">
                                                <span className="badge bg-white bg-opacity-50 text-dark border-0 rounded-pill px-3 py-2 small shadow-sm fw-600">
                                                    <i className="fas fa-map-marker-alt me-2 text-pink-600"></i> {m.city}
                                                </span>
                                            </div>

                                            <div className="mt-3 d-flex flex-column gap-1 mb-3">
                                                {m.match.instagram && (
                                                    <div className="small fw-700 text-dark d-flex align-items-center gap-2">
                                                        <i className="fab fa-instagram text-pink-600" style={{ width: '16px' }}></i>
                                                        <a href={`https://instagram.com/${m.match.instagram.replace('@', '')}`} target="_blank" rel="noreferrer" className="text-decoration-none text-dark">
                                                            {m.match.instagram.startsWith('@') ? m.match.instagram : `@${m.match.instagram}`}
                                                        </a>
                                                    </div>
                                                )}
                                                {m.match.facebook && (
                                                    <div className="small fw-700 text-dark d-flex align-items-center gap-2">
                                                        <i className="fab fa-facebook-f text-pink-600" style={{ width: '16px' }}></i>
                                                        <a href={m.match.facebook} target="_blank" rel="noreferrer" className="text-decoration-none text-dark overflow-hidden text-nowrap" style={{ textOverflow: 'ellipsis', maxWidth: '200px' }}>
                                                            {m.match.facebook.replace('https://www.facebook.com/', '').replace('https://facebook.com/', '')}
                                                        </a>
                                                    </div>
                                                )}
                                                {m.match.email && (
                                                    <div className="small fw-700 text-dark d-flex align-items-center gap-2">
                                                        <i className="fas fa-envelope text-pink-600" style={{ width: '16px' }}></i>
                                                        <a href={`mailto:${m.match.email}`} className="text-decoration-none text-dark">
                                                            {m.match.email}
                                                        </a>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="pt-3 border-top mt-auto">
                                                <button
                                                    onClick={() => onChat(m.match)}
                                                    disabled={!m.match.userId}
                                                    className="btn btn-danger rounded-pill px-4 py-2 shadow-sm border-0 d-flex align-items-center justify-content-center gap-2 fw-900 w-100"
                                                    style={{
                                                        background: m.match.userId ? 'linear-gradient(45deg, #db2777, #f43f5e)' : '#ccc',
                                                        fontSize: '0.85rem',
                                                        opacity: m.match.userId ? 1 : 0.5
                                                    }}
                                                >
                                                    <i className="fas fa-comment"></i>
                                                    <span>CHAT DM</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MyMatches;
